import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import Subsection from "./Subsection";
import Subsubheader from "./Subsubheader";
import QuoteLeft from "./QuoteLeft";

function QuoteSubsection(props) {
  const quotes = props.quotes ?? [];
  return (
    <Subsection title={props.title}>
      <div>
        <ReactMarkdown plugins={[gfm]} children={props.children} />
      </div>
      {quotes.map((quote, i) => (
        <React.Fragment key={i}>
          {quote.title && <Subsubheader>{quote.title}</Subsubheader>}
          <QuoteLeft author={quote.author}>
            {quote.text}
          </QuoteLeft>
        </React.Fragment>
      ))}
    </Subsection>
  );
}

export default QuoteSubsection;
